import { Table } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { DataTable } from '@/components/ui-shared/Tables/DataTable'
import { DeploymentOverviewApp } from '@/types/deploymentGroup'
import { DeploymentAppRows } from '../DeploymentTree/DeploymentAppRows'
import { DeploymentTreeSlots } from '../DeploymentTree/deploymentTreeTypes'
import {
  DeploymentListFilter,
  DeploymentListFilterConfig
} from './DeploymentListFilter/DeploymentListFilter'

type DeploymentListProps = DeploymentTreeSlots & {
  apps: DeploymentOverviewApp[]
  groupsEnabled: boolean
  filterConfig: DeploymentListFilterConfig
  isLoading?: boolean
  hasError?: boolean
  onFilter: (filterConfig: DeploymentListFilterConfig) => void
  onReload: () => void
}

export const DeploymentList = ({
  apps,
  groupsEnabled,
  filterConfig,
  isLoading,
  hasError,
  onFilter,
  onReload,
  ...slots
}: DeploymentListProps) => {
  const hasActiveFilter = Object.values(filterConfig).some(Boolean)

  return (
    <DataTable
      filters={
        (apps.length > 0 || hasActiveFilter) && (
          <DeploymentListFilter
            filterConfig={filterConfig}
            onFilterChange={onFilter}
          />
        )
      }
      hasItems={apps.length > 0}
      isLoading={isLoading}
      hasError={hasError}
      hasActiveFilter={hasActiveFilter}
      emptyMessage={<FormattedMessage id="deployments.list.empty" />}
      onReload={onReload}
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th>
            <FormattedMessage id="deployments.list.columns.deployment" />
          </Table.Th>

          <Table.Th w={220}>
            <FormattedMessage id="deployments.list.columns.gpu" />
          </Table.Th>

          <Table.Th w={240}>
            <FormattedMessage id="deployments.list.columns.status" />
          </Table.Th>

          <Table.Th w={160}>
            <FormattedMessage id="deployments.list.columns.actions" />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>

      <Table.Tbody>
        {apps.map((app) => (
          <DeploymentAppRows
            key={app.application_id}
            app={app}
            groupsEnabled={groupsEnabled}
            highlightedStreamId={filterConfig.stream_id || undefined}
            highlightedGroupId={filterConfig.group_id || undefined}
            {...slots}
          />
        ))}
      </Table.Tbody>
    </DataTable>
  )
}
